export default {
  headlineFontWeight: '600',
};
